import { ContractCreationFileType } from './contract-creation-file.type';

export class FileTypeItem {
    public readonly value: ContractCreationFileType;
    public readonly label: string;

    constructor(value: ContractCreationFileType, label: string) {
        this.value = value;
        this.label = label;
    }
}



// WEBPACK FOOTER //
// ./src/app/pages/common/contract-from-file/file-type.item.ts